import { useState, useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import camisas from "../data/camisas";
import CardCamisa from "../components/CardCamisa/CardCamisa";
import ModalCamisa from "../components/ModalCamisa/ModalCamisa";

export default function TimeEuropa() {
  const { time } = useParams();
  const location = useLocation();
  const [camisaSelecionada, setCamisaSelecionada] = useState(null);

  useEffect(() => {
    setCamisaSelecionada(null);
  }, [location.pathname]);

  const camisasDoTime = camisas.filter((c) => c.time === time);

  const masculinas = camisasDoTime.filter(
    (c) =>
      c.tipo === "masculino" && !c.edicaoEspecial && c.categoria === "oficial"
  );

  const jaquetas = camisasDoTime.filter(
    (c) => c.categoria === "jaqueta" && !c.edicaoEspecial
  );

  const edicaoEspecial = camisasDoTime.filter((c) => c.edicaoEspecial);

  const renderGrid = (lista) => (
    <div className="grid">
      {lista.map((camisa) => (
        <CardCamisa
          key={`${camisa.time}-${camisa.id}`}
          camisa={camisa}
          onClick={setCamisaSelecionada}
        />
      ))}
    </div>
  );

  return (
    <div className="container">
      <h1 className="page-title">{time.replaceAll("-", " ")}</h1>

      {masculinas.length > 0 && (
        <>
          <h2 className="section-title">Camisas</h2>
          {renderGrid(masculinas)}
        </>
      )}

      {edicaoEspecial.length > 0 && (
        <>
          <h2 className="section-title">Edição Especial</h2>
          {renderGrid(edicaoEspecial)}
        </>
      )}

      {jaquetas.length > 0 && (
        <>
          <h2 className="section-title">Jaquetas</h2>
          {renderGrid(jaquetas)}
        </>
      )}

      {camisaSelecionada && (
        <ModalCamisa
          camisa={camisaSelecionada}
          onClose={() => setCamisaSelecionada(null)}
        />
      )}
    </div>
  );
}
